module.exports = __webpack_public_path__ + "static/media/bwaso.8eedf364.ogg";